module.exports = __webpack_public_path__ + "static/media/61J+tfh433L._SL1200_.d1c6232f.jpg";